import { render, staticRenderFns } from "./preview-asset-form.vue?vue&type=template&id=45bc3d26&scoped=true&"
import script from "./preview-asset-form.vue?vue&type=script&lang=ts&"
export * from "./preview-asset-form.vue?vue&type=script&lang=ts&"
import style0 from "./preview-asset-form.vue?vue&type=style&index=0&id=45bc3d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bc3d26",
  null
  
)

export default component.exports